import { DatePicker } from '@3plearning/react-components';

export const ALL_CLASSES = 'All classes';
export const ALL_GROUPS = 'All groups';
export const ALL_STUDENTS = 'All students';
export const ALL_YEARS = 'All years';
export const ALL_TEACHERS = 'All teachers';

export const ALL_YEARS_TRANS = 'Report Filters - All years';
export const ALL_TEACHERS_TRANS = 'Report Filters - All teachers';

export const ACTIVITY_MASTERY = 'Activity Mastery';
export const PARTICIPATION = 'Participation';
export const LIVE_MATHS = 'Live Mathletics';
export const SKILL_QUESTS_MASTERY = 'Skill Quests Mastery';

export const YEAR_GROUP_LIST = 'yearGroupList';
export const TEACHER_LIST = 'teacherList';
export const CLASS_LIST = 'classList';
export const GROUP_LIST = 'groupList';
export const STUDENT_LIST = 'studentList';
export const REPORT_LIST = 'reportList';
export const DATE_LIST = 'dateList';

export const SELECTED_CLASS = 'selectedClass';
export const SELECTED_GROUP = 'selectedGroup';
export const SELECTED_STUDENT = 'selectedStudent';
export const SELECTED_REPORT = 'selectedReport';
export const SELECTED_DATE = 'selectedDate';
export const SELECTED_YEAR_GROUP = 'selectedYearGroup';
export const SELECTED_TEACHER = 'selectedTeacher';

export const ACTIVITY = 'Activity';
export const RESULTS = 'Results';
export const ATTEMPTS = 'Attempts';
export const NUM_ACTIVITIES = 'Num Activities';
export const TEACHERS = 'Teachers';
export const TOPICS = 'Topics';
export const ACTIVITIES = 'Activities';
export const LEVEL = 'LEVEL';
export const LEVEL_LOWERCASE = 'level';

export const FILTER_TO_DROPDOWN_MAP = {
    [SELECTED_YEAR_GROUP]: YEAR_GROUP_LIST,
    [SELECTED_TEACHER]: TEACHER_LIST,
    [SELECTED_CLASS]: CLASS_LIST,
    [SELECTED_GROUP]: GROUP_LIST,
    [SELECTED_STUDENT]: STUDENT_LIST,
    [SELECTED_REPORT]: REPORT_LIST,
    [SELECTED_DATE]: DATE_LIST
};

export const DROPDOWN_TO_FILTER_MAP = {
    [YEAR_GROUP_LIST]: SELECTED_YEAR_GROUP,
    [TEACHER_LIST]: SELECTED_TEACHER,
    [CLASS_LIST]: SELECTED_CLASS,
    [GROUP_LIST]: SELECTED_GROUP,
    [STUDENT_LIST]: SELECTED_STUDENT,
    [REPORT_LIST]: SELECTED_REPORT,
    [DATE_LIST]: SELECTED_DATE
};

export const ALL_YEARS_OPTION = { label: ALL_YEARS, value: ALL_YEARS };
export const ALL_TEACHERS_OPTION = { label: ALL_TEACHERS, value: ALL_TEACHERS };
export const ALL_CLASSES_OPTION = { label: ALL_CLASSES, value: ALL_CLASSES };
export const ALL_GROUPS_OPTION = { label: ALL_GROUPS, value: ALL_GROUPS };
export const ALL_STUDENTS_OPTION = { label: ALL_STUDENTS, value: ALL_STUDENTS };

export const ACTIVITY_MASTERY_OPTION = {
    label: ACTIVITY_MASTERY,
    value: ACTIVITY_MASTERY
};
export const PARTICIPATION_OPTION = {
    label: PARTICIPATION,
    value: PARTICIPATION
};
export const LIVE_MATHS_OPTION = {
    label: LIVE_MATHS,
    value: LIVE_MATHS
};
export const SKILL_QUESTS_MASTERY_OPTION = {
    label: SKILL_QUESTS_MASTERY,
    value: SKILL_QUESTS_MASTERY
};
export const REPORT_OPTIONS = [
    PARTICIPATION_OPTION,
    ACTIVITY_MASTERY_OPTION,
    SKILL_QUESTS_MASTERY_OPTION,
    LIVE_MATHS_OPTION
];

export const LIST_TO_ALL_OPTION = {
    [YEAR_GROUP_LIST]: ALL_YEARS_OPTION,
    [TEACHER_LIST]: ALL_TEACHERS_OPTION,
    [CLASS_LIST]: ALL_CLASSES_OPTION,
    [GROUP_LIST]: ALL_GROUPS_OPTION,
    [STUDENT_LIST]: ALL_STUDENTS_OPTION
};

export const MIN_GROUP_LENGTH = 2;

export const DATE_RANGE_OPTIONS = {
    [DatePicker.THIS_SCHOOL_YEAR]: 0,
    [DatePicker.THIS_WEEK]: 1,
    [DatePicker.LAST_WEEK]: 2,
    [DatePicker.CUSTOM_DATE]: 3,
    [DatePicker.LIFETIME]: 4
};



// WEBPACK FOOTER //
// ./components/report-filters/filter-constants.js